import type { ApiResponseError } from "#common";
import type {
  BankIdStatus,
  ProgressStatus,
  RfaCodes,
} from "#types/core/bank-id.ts";

export class BankIdError extends Error {
  messagesCode: RfaCodes;
  status: BankIdStatus;
  progressStatus?: ProgressStatus;
  code?: number; // The HTTP status code of the response

  constructor(
    messagesCode: RfaCodes,
    status: BankIdStatus,
    progressStatus?: ProgressStatus,
    code?: number,
  ) {
    super(status);
    this.name = "BankIdError";
    this.messagesCode = messagesCode;
    this.status = status;
    this.progressStatus = progressStatus;
    this.code = code;
  }

  static is(obj: any): obj is BankIdError {
    return Boolean(
      obj &&
        obj.name === "BankIdError" &&
        typeof obj.messagesCode === "string" &&
        typeof obj.status === "string",
    );
  }

  static isStartFailedError(obj: unknown): obj is BankIdError {
    return BankIdError.is(obj) && obj.progressStatus === "start_failed";
  }

  static isUserCancelError(obj: unknown): obj is BankIdError {
    return BankIdError.is(obj) && obj.progressStatus === "user_cancel";
  }
}

export function isBankIdResponseError(
  error: any,
): error is BankIdResponseError {
  return Boolean(
    error &&
      error.name === "ApiResponseError" &&
      error.data &&
      typeof error.data.status === "string" &&
      typeof error.data.message_code === "string",
  );
}

interface BankIdResponseError extends ApiResponseError {
  readonly data: {
    readonly message_code: RfaCodes;
    readonly status: BankIdStatus;
    readonly progress_status?: ProgressStatus;
  };
}
